<template lang="pug">
  svg.svg-kitchen(:width="width" :height="height" :viewBox="viewBox" preserveAspectRatio="xMidYMin meet")
    // Example Instructions
    //SvgIngredientSpriteSheet
    //SvgExampleMix(:width="svgDimensions.width" :height="svgDimensions.height" :counterX="sinkX + 180")
    g(:transform="instructionTransform")
      SvgExternal(v-show="instructionIndex === 1"  path="mix-instruction")
      SvgExternal(v-show="instructionIndex === 2" path="proof-dough")
      SvgExternal(v-show="instructionIndex === 3" path="roll-dough")
      SvgExternal(v-show="instructionIndex === 4" path="roll-dough-top-down")
      SvgExternal(v-show="instructionIndex === 5" path="spiral-dough")
      SvgExternal(v-show="instructionIndex === 6" path="spiral-dough-top-down")
      SvgExternal(v-show="instructionIndex === 7" path="bake-rolls")

    // Titlebar and Columns
    rect(:width="svgDimensions.width" :height="titleHeight"  fill="#FFE1C3")
    //rect(:width="columnWidth" :height="columnHeight" fill="#FFE1C3")
    //rect(:x="columnX" :width="columnWidth" :height="columnHeight" fill="#FFE1C3")

    // Title Text
    text.title-text.text-big(v-if="!title" :x="svgDimensions.width * 0.5" :y="70" text-anchor="middle") BAKING
    text.title-text.text-small(v-if="!title" :x="svgDimensions.width * 0.5 - 160" :y="55" text-anchor="end") THE
    text.title-text.text-small(v-if="!title" :x="svgDimensions.width * 0.5 + 160" :y="55" text-anchor="start") FORGE

    // 3D Wall and Ceiling
    //polygon(:points="ceilingPoints"   fill="#D9C5B4")
    //polygon(:points="wallPointsLeft"  fill="#A8917E")
    //polygon(:points="wallPointsRight" fill="#A8917E")

    // Counter
    SvgCounter(:x="counterX" :y="counterY" :width="counterWidth")

    // Oven and Cooktop
    template(v-if="svgDimensions.width > 2175")
      SvgOven(:x="svgDimensions.width - 675" :y="counterY" temperature="350°F" time="17:42")
      SvgOven(:x="svgDimensions.width - 350" :y="counterY" hideControl)
      SvgVent(:x="svgDimensions.width - 350" :y="titleHeight")
      SvgCooktop(:x="svgDimensions.width - 350" :y="counterY - 25")
    template(v-else)
      SvgOven(:x="svgDimensions.width - 350" :y="counterY" temperature="350°F" time="17:42")

    // Fridge and Sink
    template(v-if="svgDimensions.width > 1620")
      use(:x="25" :y="counterY - 450" width="420" height="775" href="#fridge-symbol")

    SvgSink(:x="sinkX" :y="counterY - 90")

    // Shelf and Clock
    use(:x="25 - 22" :y="titleHeight + 50" width="480" height="150" href="#shelf-symbol")
    SvgPlant(:x="25 + 350" :y="titleHeight + 55")
    SvgClock(:x="640" :y="titleHeight + 50" :width="150")

    // Logo
    g(:transform="logoTransform")
      SvgLogo(:width="logoWidth" :height="logoHeight" :small="!title")
      // text.title-text.text-big(x="-15" :y="logoHeight + 70") COMING SOON
    rect.clickable(x="0" y="0" :width="svgDimensions.width" :height="svgDimensions.height" @click="toggleTitle()")

</template>

<script>
import SvgClock from './SvgClock.vue';
import SvgCooktop from './kitchen/SvgCooktop.vue';
import SvgCounter from './kitchen/SvgCounter.vue';
import SvgExternal from './SvgExternal.vue';
import SvgLogo from './SvgLogo.vue';
import SvgOven from './kitchen/SvgOven.vue';
import SvgPlant from './kitchen/SvgPlant.vue';
import SvgSink from './kitchen/SvgSink.vue';
import SvgVent from './kitchen/SvgVent.vue';

import SvgIngredientSpriteSheet from './ingredients/SvgIngredientSpriteSheet.vue';
import SvgExampleMix from './instructions/SvgExampleMix.vue';

const MINIMUM_WIDTH = 1000;
const MAXIMUM_WIDTH = 2400;
const MINIMUM_HEIGHT = 1200;
const NUM_INSTRUCTIONS = 7;

export default {
  name: 'svg-kitchen',
  components: {
    SvgClock,
    SvgCooktop,
    SvgCounter,
    SvgExternal,
    SvgLogo,
    SvgOven,
    SvgPlant,
    SvgSink,
    SvgVent,

    SvgIngredientSpriteSheet,
    SvgExampleMix,
  },

  props: {
    width: Number,
    height: Number,
  },

  data() {
    return {
      title: true,
      instructionIndex: 1,
    };
  },

  computed: {
    svgDimensions() {
      let width = this.width;
      let height = this.height;
      if (width < MINIMUM_WIDTH) {
        height *= (MINIMUM_WIDTH / width);
        width = MINIMUM_WIDTH;
      }

      if (height < MINIMUM_HEIGHT) {
        width *= (MINIMUM_HEIGHT / height);
        height = MINIMUM_HEIGHT;
      }

      if (width > MAXIMUM_WIDTH) {
        width = MAXIMUM_WIDTH;
      }

      return { width, height };
    },

    aspectRatio() {
      return this.svgDimensions.width / this.svgDimensions.height;
    },

    titleHeight() {
      return this.title ? 0 : 80;
    },

    columnWidth() {
      return 0; // 85;
    },

    columnHeight() {
      return this.svgDimensions.height;
    },

    columnX() {
      return this.svgDimensions.width - this.columnWidth;
    },

    ceilingDrop() {
      return 24;
    },

    ceilingInset() {
      return 24 * this.aspectRatio;
    },

    ceilingPoints() {
      const endCeilingY = this.titleHeight + this.ceilingDrop;
      const endCeilingX = this.columnX - this.ceilingInset;
      const startCeilingX = this.columnWidth + this.ceilingInset;
      return `${this.columnWidth},${this.titleHeight} ${this.columnX},${this.titleHeight} ${endCeilingX},${endCeilingY} ${startCeilingX},${endCeilingY}`;
    },

    wallDrop() {
      return 0;
    },

    wallInset() {
      return this.ceilingInset;
    },

    wallPointsLeft() {
      const endCeilingY = this.titleHeight + this.ceilingDrop;
      const startCeilingX = this.columnWidth + this.ceilingInset;
      const wallLeftX = this.columnWidth + this.wallInset;
      const wallY = this.columnHeight - this.wallDrop;
      return `${this.columnWidth},${this.titleHeight} ${startCeilingX},${endCeilingY} ${wallLeftX},${wallY} ${this.columnWidth},${this.columnHeight}`;
    },

    wallPointsRight() {
      const endCeilingX = this.columnX - this.ceilingInset;
      const endCeilingY = this.titleHeight + this.ceilingDrop;
      const wallRightX = this.columnX - this.wallInset;
      const wallY = this.columnHeight - this.wallDrop;
      return `${this.columnX},${this.titleHeight} ${endCeilingX},${endCeilingY} ${wallRightX},${wallY} ${this.columnX},${this.columnHeight}`;
    },

    counterX() {
      return 0;
    },

    counterY() {
      return this.svgDimensions.height - 325;
    },

    counterWidth() {
      return this.svgDimensions.width;
    },

    logoTransform() {
      const middle = this.svgDimensions.width * 0.5 - 275;
      return this.title ? `translate(${middle} 300)` : 'translate(10 -10)';
    },

    logoWidth() {
      return this.title ? 550 : 158.333;
    },

    logoHeight() {
      return this.title ? 240 : 80;
    },

    sinkX() {
      return this.svgDimensions.width > 1620 ? 445 : 10;
    },

    instructionTransform() {
      const x = this.sinkX + 200;
      const y = this.counterY - 280;
      return `translate(${x} ${y})`;
    },

    viewBox() {
      return `0 0 ${this.svgDimensions.width} ${this.svgDimensions.height}`;
    },
  },

  methods: {
    toggleTitle() {
      //this.title = !this.title;
      this.instructionIndex += 1;
      if (this.instructionIndex > NUM_INSTRUCTIONS) {
        this.instructionIndex = 1;
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-kitchen {
  background-color: #F2F2F2;

  .title-text {
    font-family: sans-serif;
  }

  .text-big {
    font-size: 80px;
  }

  .text-small {
    font-size: 40px;
  }

  .animate {
    transition: all 0.5s;
  }

  .logo {
    transition: all 0.5s 0.5s;
  }

  rect.clickable {
    stroke: #fff;
    fill: #fff;
    fill-opacity: 0;
    stroke-opacity: 0;
  }
}
</style>
